import { postApi } from 'util/api';
import { select } from 'redux-saga/effects';
import { getAuth } from './auth';

const log = (value, id) => {
  const authValue = select(getAuth);
  postApi('/auth/logMessage', { ontracLog: value, adminUserId: id });
};

export default log;
